'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import { colors } from '../Colors/index.js';
import { Typo } from './styled.css.js';

var Typography = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'p' : _b, _c = _a.name, name = _c === void 0 ? 'paragraph' : _c, _d = _a.size, size = _d === void 0 ? 'large' : _d, className = _a.className, style = _a.style, _e = _a.fontFamily, fontFamily = _e === void 0 ? 'Inter' : _e, _f = _a.color, color = _f === void 0 ? colors.primary[0] : _f, rest = __rest(_a, ["children", "variant", "name", "size", "className", "style", "fontFamily", "color"]);
    return (React__default.createElement(Typo, __assign({ ref: ref, style: __assign({}, style), className: className, as: variant, name: name, size: size, color: color, fontFamily: fontFamily }, rest), children));
});

export { Typography as default };
//# sourceMappingURL=index.js.map
